module.exports = __webpack_public_path__ + "img/logo2.fa9034a4.png";